import { Snackbar, Button } from '@material-ui/core';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'store/index';
import { removeAlert, resetSnackBar } from 'store/modules/snackBar';
import { logout } from 'store/modules/auth';
import { v4 as uuid } from 'uuid';
import { Alert } from './alert';

const GlobalSnackBar: React.FC = () => {
  const [key, setKey] = useState<string>(uuid());

  const dispatch = useDispatch();
  const snackBar = useSelector((state: RootState) => state.snackBar);

  const isSessionExpired = snackBar.alerts?.[0]?.severity === 'sessionExpired';
  const severity =
    snackBar.alerts?.[0]?.severity === 'sessionExpired' ? 'error' : snackBar.alerts?.[0]?.severity ?? 'info';

  function handleClose() {
    setKey(uuid());
    dispatch(removeAlert());
  }

  function handleLogout() {
    dispatch(logout());
    handleClose();
    dispatch(resetSnackBar());
  }

  const logoutButton = (
    <Button color="secondary" size="small" onClick={handleLogout} style={{ border: `1px solid #ffffff` }}>
      {'Login'}
    </Button>
  );
  return (
    <Snackbar key={key} open={!!snackBar.alerts?.length} autoHideDuration={10000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={severity} action={isSessionExpired ? logoutButton : undefined}>
        {snackBar.alerts?.[0]?.message}
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackBar;
